export default {
  loading: "불러오는 중...",
  open: "열기",
  close: "닫기",
  stake: "베팅 금액",
  crdr: "승/패",
  item: "항목",
  valid: "유효",
  home_preferences: "홈 환경설정",
  quick_links: "빠른 링크",
  language: "언어",
  home_page: "홈",
  favorites: "즐겨찾기",
  note: "참고",
  my_bets: "내 베팅",
  my_account: "계정",
  contact_us: "문의하기",
  report: "보고서",
  help_support: "도움말 및 고객지원",
  currency: "통화",
  others: "기타",
  welcome: "환영합니다",
  account_id: "계정 ID",
  password: "비밀번호",
  account: "계정",
  all_sports: "전체 스포츠",
  my_sports: "스포츠",
  action: "작업",
  accept_better_odds: "더 유리한 배당률 적용",
  accept_any_odds: "변경된 모든 배당률 적용",
  auto_refresh_odds: "배당률 자동 새로고침",
  auto_refresh: "자동 새로고침",
  auto_refreshing: "자동 새로고침 중...",
  all_markets: "전체 마켓",
  available_balance: "사용 가능 잔액",
  athletics: "육상",
  american_football: "미식축구",
  aussie_rules_football: "호주식 축구",
  gmail: "Gmail",
  contact_number: "연락처",

  away: "원정",

  all: "전체",
  accepted: "승인",
  add: "추가",
  add_homescreen: "홈 화면에 추가",
  abandoned: "중단",

  bet_slip: "베팅 슬립",
  bet_credit: "베팅 크레딧",
  bet_list: "베팅 목록",
  betting: "베팅",
  balance: "잔액",

  betting_statement: "베팅 내역",
  betting_rules: "베팅 규정",
  bet_types: "베팅 유형",
  bs: "대/소",
  bet_summary: "베팅 요약",
  bets: "베팅",
  basketball: "농구",
  baseball: "야구",
  badminton: "배드민턴",
  bandy: "밴디",
  boxing: "복싱",
  beach_soccer: "비치사커",
  back: "뒤로",

  casino: "카지노",
  cash_balance: "현금 잔액",
  change_account_password: "계정 비밀번호 변경",
  current_password: "현재 비밀번호",
  confirm_new_password: "새 비밀번호 확인",
  customize_sports_order: "스포츠 순서 설정",
  choice: "선택",
  credit: "입금",
  commission: "커미션",
  customize: "사용자 설정",
  cancel: "취소",
  confirmation: "확인",
  continue_bet: "베팅 계속하기",
  customer_service: "고객지원 전화",
  cricket: "크리켓",
  cycling: "사이클",
  copa_america: "코파 아메리카",
  combinations: "조합",
  create_room: "비공개 룸 생성",

  darts: "다트",
  debit: "출금",
  display_language: "표시 언어",
  default_event_sorting: "기본 경기 정렬",
  default_stake: "기본 베팅 금액",
  date: "날짜",
  draw: "무승부",
  draw_cancel: "무승부",
  dec: "소수점",
  double_line: "두 줄 보기",
  disable: "사용 안 함",
  dec_odds: "유럽식 배당률",
  id_odds: "인도네시아식 배당률",
  double_chance: "더블 찬스",
  details: "상세 정보",

  enable: "사용",
  event_sorting: "경기 정렬",
  e_sports: "e스포츠",
  esports2: "e스포츠",
  edit: "편집",
  early: "조기 마켓",
  event: "경기",
  even: "짝",
  email: "이메일",
  esports: "e스포츠",
  entry_fee: "참가비",
  exclusive: "독점",
  event_worldcup: "2026 월드컵",
  event_euro: "유로 2024",
  event_copa: "코파 2024",
  event_olympic: "2024 올림픽",
  event_club_worldcup: "클럽 월드컵",
  event_women_euro: "여자 유로",
  event_nation_league: "네이션스리그",
  event_fifa_club: "FIFA 클럽",

  es_101: "맵 1",
  es_102: "맵 2",
  es_103: "맵 3",
  es_104: "맵 4",
  es_105: "맵 5",
  es_106: "맵 6",
  es_107: "맵 7",
  es_108: "맵 8",
  es_109: "맵 9",
  es_110: "맵 10",

  fd_101: "1등 상금",
  fd_102: "2등 상금",
  fd_103: "3등 상금",

  first_goal: "첫 득점",
  first_half: "전반",
  final: "최종",
  full_time: "경기 전체",
  from: "부터",
  field_hockey: "필드하키",
  futsal: "풋살",
  fd: "4D 스페셜",
  fishing: "낚시",
  fold: "폴드",

  gaelic_football: "게일릭 풋볼",
  golf: "골프",
  games: "게임",
  given_credit: "지급 크레딧",
  group: "그룹",
  goal: "득점",
  general: "일반",
  general_betting_rules: "일반 베팅 규정",
  general_rules_market: "일반 규정: 마켓(베팅 유형)",

  half_time: "전반",
  hide_header: "헤더 숨기기",
  hk: "홍콩",
  hk_odds: "홍콩식 배당률",
  hdp: "HDP",
  home: "홈",
  hotline: "고객지원 전화",
  handball: "핸드볼",
  hurling: "헐링",
  hour: "시간",
  highlight: "하이라이트",

  id: "ID",
  ice_hockey: "아이스하키",

  joined: "참가한 룸만",
  join_now: "지금 참가",
  jackpot: "잭팟",

  keno: "키노",
  kickoff: "경기 시작",
  kabbadi: "카바디",
  kof: "더 킹 오브 파이터즈",
  ko: "KO 방식",

  lose: "패",
  lose_half: "절반 패",
  lottery: "로또",
  login: "로그인",
  logout: "로그아웃",
  last_login: "최근 로그인",
  last_transaction: "최근 거래",
  live_streaming: "라이브 스트리밍",
  live_match: "라이브 경기",
  live_chat: "실시간 채팅",
  live: "라이브",
  virtual: "가상",
  live_tv: "라이브 TV",
  livecasino: "라이브 카지노",
  loss: "손실",
  lost: "패",
  last_bet: "최근 베팅",
  last_goal: "마지막 득점",
  leave_room: "룸 나가기",
  last_betting_time: "최종 베팅 시간",
  lose_all: "전체 패",

  mobile: "모바일",
  message: "메시지",
  my_bet: "내 베팅",
  my_favorites: "내 즐겨찾기",
  market_type: "마켓 유형",
  match: "경기",
  message_history: "메시지 내역",
  my: "내 메뉴",
  market: "마켓",
  main_markets: "주요 마켓",
  my_odds: "말레이식 배당률",
  mmo_parlay: "미얀마 조합 베팅",
  mmo_odds: "미얀마식 배당률",
  min: "최소",
  max: "최대",
  max_payout: "최대 지급액",
  main: "주요",
  corners: "코너킥/카드",
  specials: "스페셜",
  mix_parlay: "조합 베팅",
  mma: "종합격투기(MMA)",
  motorsports: "모터스포츠",
  muay_thai: "무에타이",
  map1: "맵 1",
  map2: "맵 2",
  map3: "맵 3",
  map4: "맵 4",
  map5: "맵 5",
  map6: "맵 6",
  map7: "맵 7",
  map8: "맵 8",
  map9: "맵 9",
  matches: "경기",
  mini_arcade: "미니 아케이드",
  match_started: "-",

  no_goal: "무득점",
  normal_announcements: "일반 공지",
  nickname: "닉네임",
  new_password: "새 비밀번호",
  new: "새 항목",
  "no/": "번호",
  normal_sorting: "기본 정렬",
  netball: "넷볼",
  newsinfo: "뉴스 및 정보",
  next: "다음",

  olympic: "올림픽",
  other_markets: "기타 마켓",
  outstanding: "미결",
  odds_type: "배당 유형",
  odds: "배당률",
  opening_balance: "기초 잔액",
  outright: "우승팀",
  oe: "O/E",
  on: "켜짐",
  off: "꺼짐",
  outstanding_bet: "미결 베팅",
  over: "오버",
  odd: "홀",
  official_link: "공식 링크",
  owner: "방장",
  ou: "O/U",

  password_expiry: "비밀번호 만료",
  parlay: "조합 베팅",
  parlay_early: "조기 조합 베팅",
  page_display: "페이지 표시",
  page_type: "페이지 유형",
  page_size: "페이지당 표시 개수",
  personal_message: "개인 메시지",
  process_bet: "베팅하기",
  payout: "지급액",
  pending: "대기 중",
  personal: "개인",
  play_now: "지금 플레이",
  parlay_generator: "조합 베팅 생성기",
  private: "비공개",
  pool: "지급액 $",
  players: "플레이어",
  points: "포인트",
  prize: "상금",
  play_to_earn: "플레이하고 적립",

  quick_bet: "빠른 베팅",
  qq: "QQ",

  room: "룸",
  result: "결과",
  restore: "복원",
  remark: "비고",
  ref_no: "참조 번호",
  remove_from_parlay: "조합 베팅에서 제거",
  running: "진행 중",
  reject: "거절",
  rejected: "거절",
  rugby: "럭비",
  roundof16: "16강",
  quater_finals: "8강",
  semi_finals: "준결승",
  room_id: "룸 ID",
  refund: "환불",

  skype: "Skype",
  sports: "스포츠",
  show_balance: "잔액 표시",
  statement: "내역",
  settings: "설정",
  search_team: "팀 검색",
  show_header: "헤더 표시",
  submit: "제출",
  set_nickname: "닉네임 설정",
  single: "단일 베팅",
  save: "저장",
  show_score_map: "스코어 맵 표시",
  status: "상태",
  sort: "정렬",
  sportsbook: "스포츠북",
  sum: "합계",
  special_announcements: "특별 공지",
  subtotal: "소계",
  single_line: "한 줄 보기",
  sort_by_time: "시간순 정렬",
  slots: "슬롯",
  select_leagues: "리그 선택",
  special: "스페셜",
  scroll_bottom: "탭하여 베팅 영역으로 이동",
  swipe_to_search: "밀어서 검색",
  soccer: "축구",
  squash: "스쿼시",
  sepak_takraw: "세팍타크로",
  snooker: "스누커/당구",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "마카오 스위트",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI 카지노",
  suite_sexy: "Sexy Casino",
  suite_onlive: "Onlive Casino",
  suite_mt: "MT 카지노",
  suite_foxy: "Foxy Casino",
  sfv_101: "1라운드",
  sfv_102: "2라운드",
  sfv_103: "3라운드",
  sfv_104: "4라운드",
  sfv_105: "5라운드",
  settlement: "정산",
  settled_amount: "정산 금액",
  sfv: "스트리트 파이터 V",
  search: "검색",
  sysparlay: "시스템 조합 베팅",
  stake_per_bet: "베팅당 금액",
  score: "점수",
  winner: "승자",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pragmatic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  slot_epw: "Epicwin",
  slot_epwmg: "Epicwin Mini",
  selected: "선택됨",
  select_matches: "경기 선택",
  slots_rules: "슬롯 게임 규정",

  turnover: "베팅액",
  today: "오늘",
  time: "시간",
  team: "팀",
  to: "까지",
  trans_time: "거래 시간",
  total: "합계",
  total_goal: "총 득점",
  treble: "3폴드",
  total_bets: "총 베팅 수",
  tnc: "일반 이용약관",
  tennis: "테니스",
  table_tennis: "탁구",
  telegram: "Telegram",
  tournament: "토너먼트",
  total_points: "총 포인트",
  tournament_refund: "토너먼트 환불",

  under: "언더",
  void: "무효",
  volleyball: "배구",
  void_list: "무효 목록",
  view_odds: "배당률 보기",
  video: "영상",

  won_all: "전체 승",
  won_half: "절반 승",
  win_half: "절반 승",
  win: "승",
  won: "승",
  waiting: "대기 중",
  wechat: "WeChat",
  whatsapp: "WhatsApp",
  winter_sports: "동계 스포츠",
  water_polo: "수구",
  winner_rank: "우승 순위",

  yes: "예",
  no: "아니요",

  yesterday: "어제",
  monday: "월요일",
  tuesday: "화요일",
  wednesday: "수요일",
  thursday: "목요일",
  friday: "금요일",
  saturday: "토요일",
  sunday: "일요일",

  all_league: "전체",
  match_completed: "완료",
  match_pending: "결과 대기 중",
  match_cancelled: "환불",
  match_cancelled_1h: "전반 환불",
  match_cancelled_2h: "후반 환불",
  match_suspended: "중단",
  match_suspended_1h: "전반 중단",
  match_suspended_2h: "후반 중단",

  check_all: "전체 선택",
  selected_only: "선택 항목만",
  filtered: "필터 적용",
  turn_on: "켜짐",
  turn_off: "꺼짐",

  more_bet_types: "더 많은 베팅 유형",
  switch_to_desktop: "데스크톱 버전으로 전환",

  events: "경기",
  brackets: "대진표",
  standing: "순위",

  big_small: "대/소",
  odd_even: "홀/짝",

  first_digit: "첫 번째 자리",
  second_digit: "두 번째 자리",
  third_digit: "세 번째 자리",
  forth_digit: "네 번째 자리",
  total_4d: "4D 합계",
  total_3d: "끝 3자리 합계",
  total_1st2d: "첫 2자리 합계",
  total_last2d: "끝 2자리 합계",
  total_winlose: "총 승패",
  tomorrow: "내일",

  news: "뉴스",
  more: "더 보기",
  current_live: "현재 라이브",
  upcoming: "예정",
  prematch: "경기 전",
  desktop_view: "데스크톱 보기",
  back_to_lobby: "로비로 돌아가기",
  coming_soon: "곧 출시됩니다...",
  no_record: "기록이 없습니다",
  bet_time: "베팅 시간",
  seven_days: "최근 7일",
  fourteen_days: "최근 14일",
  winlose: "승/패",
  all_transaction: "전체 거래",
  transfer: "이체",
  hide: "숨기기",
  more_details: "상세 정보 더 보기",
  bet: "베팅",
  comm: "커미션",
  settled: "정산 완료",
  total_stake: "총 베팅 금액",
  deselect_all: "전체 선택 해제",
  select_all: "전체 선택",
  done: "완료",
  early_all: "조기 마켓(전체)",
  more_markets: "더 많은 마켓",
  folds_2: "2폴드",
  folds_3: "3폴드",
  folds_4: "4폴드",
  folds_5: "5폴드",
  folds_6: "6폴드",
  folds_7: "7폴드",
  folds_8: "8폴드",
  folds_9: "9폴드",
  folds_10: "10폴드",
  folds_11: "11폴드",
  folds_12: "12폴드",
  go_today_matches: "오늘 경기로 이동",
  go_live_matches: "라이브 경기로 이동",
  remember_stake: "베팅 금액 기억",
  confirm: "확인",
  parlay_slip: "조합 베팅 슬립",
  parlay_slip_selection: "조합 베팅 슬립 - 선택",
  remove_all: "전체 삭제",
  add_more_selection: "선택 항목 더 추가",
  retain_selections: "선택 항목 유지",
  settled_remark: "오늘 마켓의 베팅이 표시됩니다. 정산된 경기의 베팅 티켓은 내역으로 이동됩니다.",
  w4d: "4D",
  tutorial_tooltips: "이 앱을 홈 화면에 설치하는 방법",
  tutorial: "튜토리얼 다시 보기",
  dismiss: "닫기",
  euroDate: "6월 12일 - 7월 12일",
  goto_statement: "내역으로 이동",
  no_bet: "베팅 없음",

  random_pick: "생성",
  add_pick: "베팅 슬립에 추가",

  worldcup: "2026 월드컵",
  time_remaining: "남은 시간",

  slot_championstar: "Champion Star",
  slot_fifafiesta: "Fifa Fiesta",
  slot_penaltymania: "Penalty Mania",
  minigame_dragon: "Dragon's Treasure",
  minigame_illuvium: "Illuvium Master",
  minigame_mobo: "Mobox Olympia",

  egames: "가상 게임",
  feedback: "의견 보내기",
  ranking: "순위",
  total_winning: "총 당첨금",
  first_prize: "1등 상금",
  second_prize: "2등 상금",
  third_prize: "3등 상금",
  place: "순위",
  current_point: "현재 포인트",
  free_room: "무료 룸",
  last_join_time: "최종 참가 시간",
  archery: "양궁",
  ufc: "UFC",
  winter_olympic: "동계 올림픽",
  no1: "<sup>1</sup>위 우승자",
  adjustment: "조정",
  poker: "포커",
  poker_db: "DB Poker",
  yellow: "노랑",
  blue: "파랑",
  first_ball: "첫 번째 공",
  best_5_balls: "최고 5개 공",
  binary_allin: "바이너리",
  best_3_balls: "최고 3개 공",
  red: "빨강",
  green: "초록",
  ball_1: "공 #1",
  ball_2: "공 #2",
  ball_3: "공 #3",

  cashout: "캐시아웃",
  cashout_amount: "캐시아웃 금액",
  dark: "다크",
  light: "라이트",
  live_now: "현재 라이브",
  upcoming_matches: "예정 경기",
  others_game: "기타 게임",
  virtual_sports: "가상 배틀 게임",
  more_hdp_markets: "더 많은 핸디캡 마켓",
  statistics: "통계",
  asia_hdp: "아시안 핸디캡",
  mmo: "MMO",
  available: "이용 가능",
  bomberman: "Super Bomberman",
  mario: "Mario Party",
  cock_fight: "닭싸움",
  marble_rafting: "Marble Rafting",
  naruto: "Naruto",
  dragon_ball: "Dragon Ball",
  marble_survival: "Marble Survival",
  marble_clash: "Marble Clash",
  marble_run: "Marble Run",
  tekken8: "Tekken 8",
  speedway: "스피드웨이",
  greyhound: "그레이하운드",
  mortal_kombat: "Mortal Kombat",
  kof: "더 킹 오브 파이터즈",
  ufc3: "UFC 3",
  street_fighter: "Street Fighter",
  round1: "1라운드",
  round2: "2라운드",
  round3: "3라운드",

  round1_1stBoom: "1라운드 첫 번째 붐",
  round2_1stBoom: "2라운드 첫 번째 붐",
  round3_1stBoom: "3라운드 첫 번째 붐",

  ft: "경기 전체",
  ht: "전반",
  classic_view: "클래식 보기",
  modern_view: "모던 보기",
  time_machine_tm: " (타임머신)",
  back: "뒤로",
};